import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import CmsContext from 'context/CmsContext';
import * as c from '../constant';
import * as actions from '../action';

function UpdateModal({
  createInput,
  createInputNumber,
  updateRequirement,
  formData,
  getRequirementList,
  updateList,
  setFormData,
  showRequirement,
  id,
  history,
}) {
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateRequirement(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      getRequirementList();
      showRequirement(id);
      history.push(`/general-settings/requirements/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, {});
  
  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true, minLength: 3 }
            )}
          </div>
          {_.get(CMS_VARIABLES, 'LGU_NAME') === "Las Piñas" && (
            <>
              <div className="col-6 form-group">
                {createInputNumber(
                  { key: 'quantity', label: 'Quantity:' },
                  { minLength: 1 }
                )}
              </div>
              <div className="d-flex col-6 form-group align-items-center pt-4">
                <label htmlFor="last_name" className="form-label pt-2">
                  Required: &nbsp;
                </label>
                <input
                  name="is_required"
                  type="checkbox"
                  checked={_.get(formData, 'is_required')}
                  onChange={onChange}
                />
              </div>
            </>
          )}
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { minLenght: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'note', label: 'Note:' },
              { minLength: 3 }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateRequirement: PropTypes.instanceOf(Function).isRequired,
  getRequirementList: PropTypes.instanceOf(Function).isRequired,
  showRequirement: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
